// removed by extract-text-webpack-plugin
module.exports = {"Block":"_3fm7YovCYzkg5wUfvrU0KV","Col_1":"_2s6dcOeI1nGuJv2MlOXcJ3","Col_2":"_11rH0WKOjVp3GJG0IkEcMf","Col_3":"_2RBRH8Ta8MSo4Cyj3HAVlc","Divider":"_3pJlUAqedg8VsGfN_d6A7_","BlockTitle":"_1yFrxG81-Ok_-Fbvou7FnD","MainColumn":"_31vyjkCouVcRXuC97pJ8U2","SideColumn":"agHP5DtXd_gSfE0yJxprh","StackOnMobile":"_1twLPCdBpTcTvo2YaDyN34","container-fluid":"_3b7BW8kjryQsv6OxuySc3u","Col_2_3":"_3eCOeVdzoGjlDB-Yg3T5vO"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Pay/styles.module.css
// module id = 206
// module chunks = 0